import { lendingUrl } from '@/constant';
import { RouterV2Enum } from '@/router/router-names';
import { VerifySceneEnum } from '@/shared/verify-credit-controller/types';

export enum LivenessProjectEnum {
  ZYQ = '1', // 臻有钱
  Campus = '2', // 校园助力金
  ListCommodity = '3', // 列表贷超
}

export enum LivenessSceneEnum {
  /** 授信 */
  Authority = '1',
  /** 修改交易密码 */
  ChangePassword = '2',
  /** 提现时补录 */
  Apply = '3',
  /** 第一次设置交易密码 */
  SetPassword = '4',
  /** 注销用户信息 */
  Logout = '5',
  /** 资料填写完成 */
  MaterialSuccess = '6',
  /** h5提现 同意提现协议时做活体 */
  ConfirmApplyContract = '7',
  /** h5提现 未绑卡时做活体 */
  NoBankCardApplyContract = '8'
}

export const LivenessSceneEnumUrl = {
  Authority: `${lendingUrl + RouterV2Enum.preApplyChoose}`, // 授信
  ChangePassword: `${lendingUrl + RouterV2Enum.applyProduct}`, // 修改交易密码
  Apply: `${lendingUrl + RouterV2Enum.applyProduct}`, // 提现时补录
  SetPassword: `${lendingUrl + RouterV2Enum.applyProduct}`, // 第一次设置交易密码
  Logout: `${lendingUrl + RouterV2Enum.home}`, // 注销用户信息
};


const h5Url = `${window.location.origin + window.location.pathname}#`;
// 端外 H5活体跳转地址
export const LivenessSceneEnumH5Url = {
  Authority: `${h5Url + RouterV2Enum.verifyCredit}?scene=${VerifySceneEnum.CREDIT_PRE_VERIFY}`, // h5活体验证后，回跳到资料页获取活体结果 以及 后续资料填写
  ChangePassword: `${h5Url + RouterV2Enum.applyProduct}?h5Bio=true&sceneType=${LivenessSceneEnum.ChangePassword}`, // 修改交易密码
  Apply: `${h5Url + RouterV2Enum.applyProduct}?h5Bio=true&sceneType=${LivenessSceneEnum.Apply}`, // 提现时补录
  SetPassword: `${h5Url + RouterV2Enum.applyProduct}?h5Bio=true&sceneType=${LivenessSceneEnum.SetPassword}`, // 第一次设置交易密码
};
